<template>
    <product-list-wrapper
        :title="$t('home backups title')"
        :title-message="$t('backup list message')"
        :create-button="$t('start new')"
        create-route="backupConnect"
        :connect-button="$t('backup connect new')"
        :connect-title="$t('backup connect new message')"
        no-workspace
    >
        <template #list="{ list }">
            <product-list :list="list">
                <template #item="{ item }">
                    <backup-list-item :backup="item" />
                </template>
            </product-list>
        </template>
    </product-list-wrapper>
</template>

<script>
import ProductList from '@/components/app/product/list';
import BackupListItem from '@/components/backup/components/list-item';
import ProductListWrapper from '@/components/app/product/list/wrapper.vue';

export default {
    name: 'BackupListPage',
    components: {
        BackupListItem,
        ProductList,
        ProductListWrapper,
    },
};
</script>
